import script from "./HorizontalNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./HorizontalNavbar.vue?vue&type=script&setup=true&lang=js"

import "./HorizontalNavbar.vue?vue&type=style&index=0&id=02531c71&lang=css"

const __exports__ = script;

export default __exports__